import { useState, useContext } from "react";
import Navigation from "../../components/navigation";
import LoginForm from "../../components/LoginForm";
import WindowSizeContext from "../../utils/WindowSizeContext";
import "../description/styles.css"
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUserInfo } from "../../services/StoreContainer/actionCreators";
import { clearLS } from "../../utils/ClearLocalStorage";

const Geocoder = (props) => {
    const size = useContext(WindowSizeContext);
    const navigate = useNavigate();
    const [loginForm, setLoginForm] = useState(false);

    const dispatch = useDispatch();

    return <>
        <Navigation
            showLoginForm={() => { setLoginForm(!loginForm); }}
            afterLogout={() => {
                dispatch(updateUserInfo());
                clearLS();
            }}
            isLoginShow={loginForm}
        />
        {loginForm &&
            <LoginForm
                afterLogin={() => {
                    dispatch(updateUserInfo());
                    navigate('/lk/MyDatasets');
                    setLoginForm(false);
                }}
            />
        }
        <div className="Information">
            <div id='descriptionContainer' className='descriptionContainer'>
                <h2 className="headerText activeDescription" style={{ cursor: 'auto' }}>Геокодер</h2>
                <div className='textContainer howText' style={{ height: 'fit-content' }}>
                    <h4 className='textH4'>Что умеет геокодер?</h4>
                    <p className="descriptionText minBottomMargin">Взять ваши табличные данные, в которых содержится адрес или другой признак места, и превратить их в пространственный слой. Или «обогатить» &mdash; добавить характеристики из объединенного адресного плана, например, код по ГАР/ФИАС, расстояние до школы или количество жителей.</p>
                    <h4 className='textH4'>Какие данные можно геокодировать?</h4>
                    <p className="descriptionText minBottomMargin">Любые, имеющие признак места. Чаще всего это почтовый адрес, но так же могут использоваться кадастровые номера, почтовые индексы, названия организаций по адресу. И отдельный случай, если ваши данные уже имеют гео-координаты - хотя бы примерный центроид объекта.</p>
                    <p className="descriptionText minBottomMargin">Данные можно загрузить в систему через файлы MS Excеl или GeoJSON. Можно собрать несколько файлов в архив и объединить их уже в Роботе.</p>
                    <p className="descriptionText minBottomMargin">Хорошо, если адрес полный, структурный, аккуратный, тогда геокодер безошибочно установит связь с ОАП. Если адрес неполный, или замусорен настолько, что однозначное соответствие со зданием установить невозможно, геокодер предложит менее точные ответы - до улицы, до населенного пункта.   </p>
                    <h4 className='textH4'>Как начать работу с геокодером?</h4>
                    <p className="descriptionText minBottomMargin">Зайдите в <a href="/lk/">личный кабинет</a>, добавьте свой набор данных, если Робот предложит - то &laquo;разберите&raquo; адрес или обработайте геометрию, затем свяжите свой набор с ОАП. Если останется недосвязанная часть набора, можно попробовать связать еще раз - геокодер адаптируется и выбирает немного разные алгоритмы.</p>
                    <p className="descriptionText minBottomMargin">Для наборов, связанных с ОАП, доступно &laquo;обогащение&raquo; - дополнение набора характеристиками из ОАП. Это делается в <a href="/lk/TuneMetadata">настройке структуры</a>.</p>
                    <p className="descriptionText minBottomMargin">Вы можете посмотреть свой набор в виде слоя на карте внутри Робота, опубликовав его, либо забрать как файл Excel или GeoJSON.</p>
                </div>
            </div>
        </div>
    </>
}

export default Geocoder;